import React from 'react'
import { withState } from 'recompose'
import TooltipDetached, { positions } from './detached'

class Tooltip extends React.Component {
  static defaultProps = {
    id: null,
    label: null,
    display: null,
    placement: positions.TOP,
    delay: 0,
    children: null,
    className: null,
    wrapperClass: null,
    anchorEl: null
  }

  componentDidMount() {
    this.props.setAnchorEl(this.wrapperRef)
  }

  render() {
    const {
      id,
      label,
      children,
      anchorEl,
      delay,
      display,
      placement,
      className,
      wrapperClass
    } = this.props

    return (
      <React.Fragment>
        {anchorEl && (
          <TooltipDetached
            anchorEl={anchorEl}
            label={label}
            id={id}
            placement={placement}
            delay={delay}
            className={className}
          />
        )}
        <span
          ref={ref => {
            this.wrapperRef = ref
          }}
          {...(display ? { style: { display } } : {})}
          className={wrapperClass}>
          {children}
        </span>
      </React.Fragment>
    )
  }
}

export default withState('anchorEl', 'setAnchorEl', null)(Tooltip)
